export const exportMovementsEndPoint = 'Merchant/ExportMovementsForMerchant';
